import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import moment from 'moment';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import classNames from 'classnames';
import { Form, PrimaryButton, FieldTextInput, FieldCheckboxGroup, FieldDateInput } from '../../../components';
import { findOptionsForSelectFilter } from '../../../util/search';
import config from '../../../config';

import css from './PostsSection.module.scss';

const PostsSectionFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    initialValues={props.initialValues}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        handleSubmit,
        intl,
        invalid,
        inProgress,
        postType,
        values
      } = fieldRenderProps;

      const classes = classNames(rootClassName || css.root, className);
      const categoryOptions = findOptionsForSelectFilter('category', config.custom.filters);

      const submitDisabled = (postType === "events" && !values?.eventDate?.date) || false;

      return (
        <Form
          className={classes}
          onSubmit={handleSubmit}
        >
          <div className={css.dynamicFieldWrapper}>

            <label className={css.dynamicItemLabel}>
              <FormattedMessage id="EditListingPostsForm.titleLabel" />
            </label>
            <FieldTextInput
              name="title"
              className={css.dynamicField}
              component="input"
              placeholder={'Title'}
            />

            {postType !== "events" && (
              <>
                <label className={css.dynamicItemLabel}>
                  <FormattedMessage id="EditListingPostsForm.descriptionLabel" />
                </label>
                <FieldTextInput
                  name="description"
                  className={css.dynamicField}
                  component="textarea"
                  placeholder={'Description'}
                />
              </>
            )}

            <label className={css.dynamicItemLabel}>
              <FormattedMessage id="EditListingPostsForm.linkLabel" />
            </label>
            <FieldTextInput
              name="link"
              className={css.dynamicField}
              component="input"
              placeholder={'www.example.com'}
            />

            {postType !== "events" && (
              <FieldCheckboxGroup
                label={intl.formatMessage({
                  id: 'EditListingPostsForm.catetgoryLabel',
                })}
                className={css.dynamicFieldCheckboxes}
                id="category"
                name="category"
                options={categoryOptions}
                twoColumns={true}
                radio={false}
              />
            )}

            {postType === "events" && (
              <>
                <label className={css.dynamicItemLabel}>
                  <FormattedMessage id="EditListingPostsForm.dateLabel" />
                </label>
                <FieldDateInput
                  className={classNames(css.dynamicField, css.dynamicFieldDate)}
                  name="eventDate"
                  id="eventDate"
                  useMobileMargins={false}
                  placeholderText={moment().format('ddd, MMM D')}
                  format={v =>
                    v && v.date ? {date: moment.tz(moment(v.date).format('YYYY-MM-DD HH:mm:ss'), "Etc/UTC").toDate()} : v
                  }
                  parse={v =>
                    v && v.date ? {date: v.date.toString()} : v
                  }
                />

                <label className={css.dynamicItemLabel}>
                  <FormattedMessage id="EditListingPostsForm.discountCodeLabel" />
                </label>
                <FieldTextInput
                  name="discountCode"
                  className={css.dynamicField}
                  component="input"
                  placeholder={'Enter code'}
                  maxlength="16"
                />

              </>
            )}

          </div>
          <PrimaryButton type="submit" disabled={submitDisabled} inProgress={inProgress} >
            <FormattedMessage id="ListingPage.savePost" />
          </PrimaryButton>
        </Form>
      );
    }}
  />
);

PostsSectionFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  form: null,
};

const { string, bool } = PropTypes;

PostsSectionFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  form: string,
  intl: intlShape.isRequired,
};

const PostsSectionForm = compose(injectIntl)(PostsSectionFormComponent);
PostsSectionForm.displayName = 'PostsSectionForm';

export default PostsSectionForm;
